<button type="button"
        style="padding: 10px 10px; margin: 0px 10px"
        class="btn btn-sm btn-outline-danger border-0"
        (click)="onDelete()">
  <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
</button>